import { coverDetailsFragment, coverFragment } from "@saleor/fragments/cover";
import { pageInfoFragment } from "@saleor/fragments/pageInfo";
import makeQuery from "@saleor/hooks/makeQuery";
import gql from "graphql-tag";

import { CoverDetails, CoverDetailsVariables } from "./types/CoverDetails";
import { CoverList, CoverListVariables } from "./types/CoverList";

const coverList = gql`
  ${coverFragment}
  ${pageInfoFragment}
  query CoverList(
    $filter: CoverFilterInput
    $before: String
    $after: String
    $first: Int
    $last: Int
    $sort: CoverSortingInput
  ) {
    covers(
      filter: $filter
      before: $before
      after: $after
      first: $first
      last: $last
      sortBy: $sort
    ) {
      totalCount
      edges {
        node {
          ...CoverFragment
        }
      }
      pageInfo {
        ...PageInfoFragment
      }
      totalCount
    }
  }
`;

export const useCoverListQuery = makeQuery<CoverList, CoverListVariables>(
  coverList
);

const coverDetails = gql`
  ${coverDetailsFragment}
  query CoverDetails(
    $id: ID!
    $after: String
    $before: String
    $first: Int
    $last: Int
  ) {
    cover(id: $id) {
      ...CoverDetailsFragment
    }
  }
`;

export const useCoverDetailsQuery = makeQuery<
  CoverDetails,
  CoverDetailsVariables
>(coverDetails);
